// extracted by mini-css-extract-plugin
module.exports = {"Tags":"_2x2E4"};